import {createCameraDeviceOverviewReducer} from "./CameraDeviceOverviewReducer";
import {OVERHEAD_CAMERA_SUB_ASSET_TYPE} from "../../../util/Constants";

export const OverheadCameraDeviceOverviewReducer = createCameraDeviceOverviewReducer(OVERHEAD_CAMERA_SUB_ASSET_TYPE);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/reducer/OverheadCameraDeviceOverviewReducer.js